<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
        </div>
        <div class="sa-list-component-body">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>

            <div class="b-table-sticky-header">
                <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right float-right"
                    @click="onClickAggiungiArticolo()">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                    :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light"
                    class="sa-b-table">
                    <template #cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" v-b-tooltip.hover title="Modifica Articolo" variant="outline-success"
                                @click="onModificaItems(row)">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-modal ref="mdlMagazzino" size="sm" style="height: 100%" @hide="onHideModal" centered>
                <b-form>
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <strong for="">Nome Articolo</strong>
                            <b-form-input v-model="articolo.nomeArticolo"></b-form-input>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <strong>Quantità</strong>
                            <b-form-input min="0" type="number" v-model="qtn"></b-form-input>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                            <strong>Giacenza</strong>
                            <b-form-input :disabled="true" v-model="articolo.giacenza"></b-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <template #modal-footer>
                    <b-button size="sm" variant="danger" @click="onClickOperazione(0)">Diminuisci</b-button>
                    <b-button size="sm" variant="success" @click="onClickOperazione(1)">Aumenta</b-button>
                </template>
            </b-modal>
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    mixins: [UtilityMixin],

    components: {
        // DatePicker
    },
    mounted() { },
    computed: {
        rows: function () {
            return this.items.length;
        },
    },
    data() {
        return {
            currentPage: 1,
            perPage: 20,
            rowSelezionata: null,
            qtn: 0,
            nuovo: false,
            articolo: { giacenza: 0, nomeArticolo: null },
            items: [{ giacenza: 100, nomeArticolo: "Articolo 1" }],
            filtro: {
                paziente: "",
                operatore: "",
                professione: "",
                dataDal: null,
                dataAl: null
            },
            fields: [

                {
                    label: "Articolo",
                    key: "nomeArticolo",
                    sortable: true,
                },
                {
                    label: "Giacenza Attuale",
                    key: "giacenza",
                    sortable: true,
                },
                {
                    label: "",
                    key: "actions",
                    sortable: true,
                }

            ]
        };
    },
    methods: {
        init(filtro) {
            if (filtro) {
                this.filtro = filtro;
            }
            this.loadStoricoGiacenzaArticolo();
        },
        onHideModal() {
            this.resetArticolo();

        },
        onReset() { },
        onSubmit() {
            this.items.filter(e => e.paziente.includes(this.filtro.paziente))
        },
        onModificaItems(row) {
            this.rowSelezionata = row;
            this.articolo = row.item;
            this.nuovo = false;
            this.$refs.mdlMagazzino.show();
        },
        onClickAggiungiArticolo() {
            this.$refs.mdlMagazzino.show();
            this.nuovo = true;
        },
        resetArticolo() {
            this.articolo = { giacenza: 0, nomeArticolo: null }
            this.qtn = 0;
        },
        onClickOperazione(value) {

            if (this.nuovo) {
                this.items.push(this.articolo);
                let articoloNuovo = this.items.filter(e => e.nomeArticolo == this.articolo.nomeArticolo);
                this.articolo = articoloNuovo[0];
            }
            let index = this.items.indexOf(this.articolo)
            switch (value) {
                case 0:
                    this.articolo.giacenza = new Number(this.articolo.giacenza) - new Number(this.qtn);
                    break;
                case 1:
                    this.articolo.giacenza = new Number(this.articolo.giacenza) + new Number(this.qtn);
                    break;
                default:
                    break;
            }
            this.items.splice(index, 1, this.articolo);



            this.$refs.mdlMagazzino.hide();
        }
    },
};
</script>
